// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_bytes from "melange.js/caml_bytes.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin__Infix from "./infix.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__BytesLabels from "melange/bytesLabels.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Printf from "melange/printf.js";
import * as Stdlib__StringLabels from "melange/stringLabels.js";

function init(modeOpt, block_sizeOpt, param) {
  const mode = modeOpt !== undefined ? modeOpt : /* Space */2;
  const block_size = block_sizeOpt !== undefined ? block_sizeOpt : 120;
  return {
          data: /* [] */0,
          mode: mode,
          block_size: block_size
        };
}

function size(t) {
  let _acc = 0;
  let _param = t.data;
  while(true) {
    const param = _param;
    const acc = _acc;
    if (!param) {
      return acc;
    }
    const offset = param.hd.offset;
    _param = param.tl;
    _acc = offset + acc | 0;
    continue ;
  };
}

function unused_space(t) {
  let _acc = 0;
  let _param = t.data;
  while(true) {
    const param = _param;
    const acc = _acc;
    if (!param) {
      return acc;
    }
    const match = param.hd;
    const offset = match.offset;
    _param = param.tl;
    _acc = (match.buffer.length - offset | 0) + acc | 0;
    continue ;
  };
}

function write_varint(buffer, offset, v) {
  let _offset = offset;
  let _v = v;
  while(true) {
    const v$1 = _v;
    const offset$1 = _offset;
    const next_offset = offset$1 + 1 | 0;
    const rem = Ocaml_protoc_plugin__Infix.Int64.lsr(v$1, 7);
    if (Caml.i64_neq(rem, Caml_int64.zero)) {
      buffer[offset$1] = Caml_int64.to_int32(Ocaml_protoc_plugin__Infix.Int64.lor(Ocaml_protoc_plugin__Infix.Int64.land(v$1, [
                    0,
                    127
                  ]), [
                0,
                128
              ]));
      _v = rem;
      _offset = next_offset;
      continue ;
    }
    buffer[offset$1] = Caml_int64.to_int32(v$1);
    return next_offset;
  };
}

function write_varint_unboxed(buffer, offset, v) {
  return write_varint(buffer, offset, Caml_int64.of_int32(v));
}

function write_delimited_field_length_fixed_size(buffer, offset, v) {
  const vl = Caml_int64.of_int32(v);
  const offset$1 = write_varint(buffer, offset, Caml_int64.or_(vl, [
            4,
            0
          ]));
  const v$1 = Stdlib__BytesLabels.get_uint8(buffer, offset$1 - 1 | 0);
  Stdlib__BytesLabels.set_uint8(buffer, offset$1 - 1 | 0, v$1 & 63);
  return offset$1;
}

function ensure_capacity(size, t) {
  const tl = t.data;
  if (tl) {
    const elem = tl.hd;
    const offset = elem.offset;
    if ((elem.buffer.length - offset | 0) >= size) {
      return elem;
    }
    
  }
  const elem$1 = {
    offset: 0,
    buffer: Caml_bytes.caml_create_bytes(size > t.block_size ? size : t.block_size)
  };
  t.data = {
    hd: elem$1,
    tl: tl
  };
  return elem$1;
}

function write_const_value(data, t) {
  const len = data.length;
  const elem = ensure_capacity(len, t);
  Stdlib__BytesLabels.blit_string(data, 0, elem.buffer, elem.offset, len);
  elem.offset = elem.offset + len | 0;
}

function write_fixed32_value(v, t) {
  const elem = ensure_capacity(4, t);
  Stdlib__BytesLabels.set_int32_le(elem.buffer, elem.offset, v);
  elem.offset = elem.offset + 4 | 0;
}

function write_fixed64_value(v, t) {
  const elem = ensure_capacity(8, t);
  Stdlib__BytesLabels.set_int64_le(elem.buffer, elem.offset, v);
  elem.offset = elem.offset + 8 | 0;
}

function write_varint_unboxed_value(v, t) {
  const elem = ensure_capacity(10, t);
  const offset = write_varint_unboxed(elem.buffer, elem.offset, v);
  elem.offset = offset;
}

function write_varint_value(v, t) {
  const elem = ensure_capacity(10, t);
  const offset = write_varint(elem.buffer, elem.offset, v);
  elem.offset = offset;
}

function write_length_delimited_value(data, offset, len, t) {
  write_varint_unboxed_value(len, t);
  const elem = ensure_capacity(len, t);
  Stdlib__BytesLabels.blit_string(data, offset, elem.buffer, elem.offset, len);
  elem.offset = elem.offset + len | 0;
}

function write_field_header(t, index, field_type) {
  const header = (index << 3) + field_type | 0;
  write_varint_unboxed_value(header, t);
}

function write_field(t, index, field) {
  let match;
  switch (field.TAG | 0) {
    case /* Varint */0 :
        const v = field._0;
        match = [
          0,
          (function (param) {
              return write_varint_value(v, param);
            })
        ];
        break;
    case /* Varint_unboxed */1 :
        const v$1 = field._0;
        match = [
          0,
          (function (param) {
              return write_varint_unboxed_value(v$1, param);
            })
        ];
        break;
    case /* Fixed_64_bit */2 :
        const v$2 = field._0;
        match = [
          1,
          (function (param) {
              return write_fixed64_value(v$2, param);
            })
        ];
        break;
    case /* Length_delimited */3 :
        const match$1 = field._0;
        const data = match$1.data;
        const length = match$1.length;
        const offset = match$1.offset;
        match = [
          2,
          (function (param) {
              return write_length_delimited_value(data, offset, length, param);
            })
        ];
        break;
    case /* Fixed_32_bit */4 :
        const v$3 = field._0;
        match = [
          5,
          (function (param) {
              return write_fixed32_value(v$3, param);
            })
        ];
        break;
    
  }
  write_field_header(t, index, match[0]);
  Curry._1(match[1], t);
}

function write_length_delimited_f(write_f, v, t) {
  const size_data_added = function (sentinel, _acc, _param) {
    while(true) {
      const param = _param;
      const acc = _acc;
      if (!param) {
        return Stdlib.failwith("End of list reached. This is impossible");
      }
      const x = param.hd;
      if (x === sentinel) {
        return acc;
      }
      const offset = x.offset;
      _param = param.tl;
      _acc = offset + acc | 0;
      continue ;
    };
  };
  const match = t.mode;
  switch (match) {
    case /* Balanced */0 :
        const match$1 = t.data;
        let sentinel;
        let exit = 0;
        if (match$1) {
          const sentinel$1 = match$1.hd;
          const offset = sentinel$1.offset;
          if ((offset + 5 | 0) <= sentinel$1.buffer.length) {
            sentinel = sentinel$1;
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
        if (exit === 1) {
          const sentinel$2 = {
            offset: 0,
            buffer: [
              0,
              0,
              0,
              0,
              0
            ]
          };
          t.data = {
            hd: sentinel$2,
            tl: t.data
          };
          sentinel = sentinel$2;
        }
        const offset$1 = sentinel.offset;
        sentinel.offset = Stdlib__Int.max_int;
        Curry._2(write_f, t, v);
        const size = size_data_added(sentinel, 0, t.data);
        const offset$2 = write_varint_unboxed(sentinel.buffer, offset$1, size);
        sentinel.offset = offset$2;
        return ;
    case /* Speed */1 :
        const sentinel$3 = ensure_capacity(5, t);
        const offset$3 = sentinel$3.offset;
        sentinel$3.offset = sentinel$3.offset + 5 | 0;
        Curry._2(write_f, t, v);
        const size$1 = size_data_added(sentinel$3, sentinel$3.offset - (offset$3 + 5 | 0) | 0, t.data);
        write_delimited_field_length_fixed_size(sentinel$3.buffer, offset$3, size$1);
        return ;
    case /* Space */2 :
        const sentinel$4 = ensure_capacity(5, t);
        const offset$4 = sentinel$4.offset;
        sentinel$4.offset = sentinel$4.offset + 5 | 0;
        Curry._2(write_f, t, v);
        const size$2 = size_data_added(sentinel$4, sentinel$4.offset - (offset$4 + 5 | 0) | 0, t.data);
        const offset$p = write_varint_unboxed(sentinel$4.buffer, offset$4, size$2);
        if ((offset$4 + 5 | 0) === offset$p) {
          
        } else {
          Stdlib__BytesLabels.blit(sentinel$4.buffer, offset$4 + 5 | 0, sentinel$4.buffer, offset$p, sentinel$4.offset - (offset$4 + 5 | 0) | 0);
          sentinel$4.offset = sentinel$4.offset - ((offset$4 + 5 | 0) - offset$p | 0) | 0;
        }
        return ;
    
  }
}

function contents(t) {
  const size$1 = size(t);
  const contents$1 = Caml_bytes.caml_create_bytes(size$1);
  const inner = function (_offset, _param) {
    while(true) {
      const param = _param;
      const offset = _offset;
      if (!param) {
        return offset;
      }
      const match = param.hd;
      const o = match.offset;
      const next_offset = offset - o | 0;
      Stdlib__BytesLabels.blit(match.buffer, 0, contents$1, next_offset, o);
      _param = param.tl;
      _offset = next_offset;
      continue ;
    };
  };
  const offset = inner(size$1, t.data);
  if (offset !== 0) {
    throw new Caml_js_exceptions.MelangeError("Assert_failure", {
              MEL_EXN_ID: "Assert_failure",
              _1: [
                "vendored/ocaml_protoc_plugin/writer.ml",
                192,
                2
              ]
            });
  }
  return Stdlib__BytesLabels.unsafe_to_string(contents$1);
}

function dump(t) {
  const string_contents = contents(t);
  Curry._1(Stdlib__Printf.printf(/* Format */{
            _0: {
              TAG: /* String_literal */11,
              _0: "Buffer: ",
              _1: {
                TAG: /* String */2,
                _0: /* No_padding */0,
                _1: {
                  TAG: /* Char_literal */12,
                  _0: /* '\n' */10,
                  _1: /* End_of_format */0
                }
              }
            },
            _1: "Buffer: %s\n"
          }), Stdlib__StringLabels.concat("-", Stdlib__ListLabels.init(string_contents.length, (function (i) {
                  return Curry._1(Stdlib__Printf.sprintf(/* Format */{
                                  _0: {
                                    TAG: /* Int */4,
                                    _0: /* Int_x */6,
                                    _1: {
                                      TAG: /* Lit_padding */0,
                                      _0: /* Zeros */2,
                                      _1: 2
                                    },
                                    _2: /* No_precision */0,
                                    _3: /* End_of_format */0
                                  },
                                  _1: "%02x"
                                }), Caml_string.get(string_contents, i));
                }))));
}

function of_list(fields) {
  const t = init(undefined, undefined, undefined);
  Stdlib__ListLabels.iter((function (param) {
          write_field(t, param[0], param[1]);
        }), fields);
  return t;
}

export {
  init ,
  contents ,
  write_fixed32_value ,
  write_fixed64_value ,
  write_varint_unboxed_value ,
  write_varint_value ,
  write_length_delimited_value ,
  write_const_value ,
  write_length_delimited_f ,
  write_field ,
  of_list ,
  dump ,
  unused_space ,
  write_varint ,
  write_varint_unboxed ,
}
/* No side effect */
